export default __webpack_public_path__ + "static/media/right.a8fc287c.svg";